module.exports = __webpack_public_path__ + "static/media/RESEARCH_occurrenceRate.9df573bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/RESEARCH_occurrenceRate.jpg
// module id = 158
// module chunks = 0